import { render } from "./pegawai-list-custom.vue?vue&type=template&id=54a19496"
import script from "./pegawai-list-custom.vue?vue&type=script&lang=js"
export * from "./pegawai-list-custom.vue?vue&type=script&lang=js"

import "./pegawai-list-custom.vue?vue&type=style&index=0&id=54a19496&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__